<template>
	<v-row align="center" justify="center" no-gutters>
		<p v-if="options.isEmpty" class="secondary--text">該当する部品データはありません</p>
		<v-btn
			height="auto"
			class="ma-2 pa-2"
			depressed
			v-for="ordered_product in ordered_products"
			:key="ordered_product.id"
			@click="$emit('set', ordered_product)"
			:style="$vuetify.breakpoint.xs ? 'width: 100%' : 'calc(33.33% - 16px); flex-basis: calc(33.33% - 16px); margin-left: 16px;'"
		>
			<div>
				<p>製造番号: {{ ordered_product.product_number }}</p>
				<p>製品名: {{ ordered_product.product.name }}</p>
			</div>
		</v-btn>
	</v-row>
</template>

<script>
export default {
	props: {
		ordered_products: {
			type: Array,
			default: () => [],
		},
		options: {
			isEmpty: {
				type: Boolean,
			},
		},
	},
	data() {
		return {}
	},
}
</script>
